module.exports = new __parcel__URL__("empty-cannot-view-item-darkmode.f5cb1022.svg").toString();